import { useEffect, useState } from "react";
import { useApi } from "../utils/Api";
import SpinnerOverlay from "../components/SpinnerOverlay";

export default function BookingSuccess() {
  const { apiFetch } = useApi();

  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState("");

  // Format date nicely
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-GB", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("t");

    if (!token) {
      setError("Invalid booking link.");
      setLoading(false);
      return;
    }

    let attempts = 0;
    const MAX_ATTEMPTS = 6;

    const fetchBooking = async () => {
      try {
        const res = await apiFetch("verify-success", { t: token });

        if (res.success) {
          setBooking(res.booking);
          setLoading(false);
        } else if (attempts < MAX_ATTEMPTS) {
          attempts++;
          setTimeout(fetchBooking, 2000);
        } else {
          setError(
            "Payment pending. Please refresh."
          );
          setLoading(false);
        }
      } catch (err) {
        setError("Something went wrong.");
        setLoading(false);
      }
    };

    fetchBooking();
  }, [apiFetch]);

  if (loading) {
    return (
      <div className="text-center mt-20">
        <SpinnerOverlay />
        <p className="mt-4 text-slate-600">
          Confirming your booking...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center mt-20">
        <h2 className="text-2xl font-bold text-red-600">{error}</h2>

        <button
          onClick={() => (window.location.href = "/")}
          className="mt-6 bg-primary px-6 py-3 text-white font-semibold"
        >
          Back to Home
        </button>
      </div>
    );
  }

  return (
    <div className="max-w-xl mx-auto mt-20 bg-white p-8 rounded-2xl shadow-lg text-center">
      <h2 className="text-3xl font-bold text-green-600 mb-4">
        Payment Confirmed 🎉
      </h2>

      <p className="mb-4">
        Your Easter Buffet booking is confirmed.
      </p>

      <div className="text-left mt-6 space-y-2">
        <p><strong>Booking Ref:</strong> {booking.booking_ref}</p>
        <p><strong>Name:</strong> {booking.name}</p>
        <p><strong>Date:</strong> {formatDate(booking.booking_date)}</p>
        <p><strong>Time:</strong> {booking.time_slot}</p>
        <p><strong>Adults:</strong> {booking.adults}</p>
        <p><strong>Children:</strong> {booking.children}</p>
        <p><strong>Total Paid:</strong> £{booking.amount}</p>
      </div>

      <button
        onClick={() => (window.location.href = "/")}
        className="mt-6 w-full bg-primary py-3 text-white font-semibold"
      >
        Back to Home
      </button>
    </div>
  );
}